import { Component, OnInit, ViewChild, ElementRef, Input, ChangeDetectionStrategy } from '@angular/core';
import { Constant } from './../../constants/constants';
import { Router, NavigationEnd } from '@angular/router';
import { AppService } from 'src/app/app.service';
import { Modal } from 'src/app/common/modal/modal';
import { ModalService } from 'src/app/common/modal/modal.service';
@Component({
    selector: 'app-banner-message',
    templateUrl: './banner-message.component.html',
    styleUrls: ['./banner-message.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class BannerMessageComponent implements OnInit {
  @ViewChild('bannerMessagePopup', { static: false }) bannerMessagePopup: ElementRef;
  @ViewChild('bannerDiv', { static: false }) bannerDiv: ElementRef;
  @Input() divIdObj : any;
  @Input() message: any;
  @Input() termsAndConditions:any;
  @Input() termsAndConditionsUrl:any;
  @Input() effectedComp: any;
  dynamicHeightOfBanner:any = 0;
  @ViewChild('globleMessageBanner', {static: false, read: ElementRef}) globleMessageBanner: ElementRef;
  isDisplayConditions: boolean = false;
  bannerArrayViewList : any =  ['releaseOrder', 'orderEntry'];
  routerSubscription: any = null;
  messageType : any;
  arrayOfKeys : any;
  commonSubject : any;
  selectedData : any = "defaultMsg";
  displayStyle :  any = "none";
  constructor(private modalService: ModalService, private router: Router, private appService : AppService ) {
    this.routerSubscription = router.events.subscribe((event) => {
      if (event instanceof NavigationEnd) {
        this.closeBannerPopupFn();
      }
    });
   }
  createOrderBanner = Constant.CREATE_ORDER_BANNER;
  ngOnInit() {
    if(document.getElementById("globleMessageBanner"))
    {
      this.dynamicHeightOfBanner = document.getElementById("globleMessageBanner").offsetHeight;
    }
    this.appService._commonSubjecct.subscribe((response) => {
      if (response?.event == "SHOW_BANNER_MESSAGE") {
        if (!response.message) {
          this.bannerMessagePopup.nativeElement.style.display = 'none';
          this.bannerDiv.nativeElement.style.display = 'none';
          this.createOrderBanner = response.message;
        } else {
          this.bannerMessagePopup.nativeElement.style.display = 'block';
          this.bannerDiv.nativeElement.style.display = 'block';
          this.createOrderBanner = response.message;
        }
      }
    });
    //check Meessage type is object
    if (typeof this.message === "object") {
      this.messageType = "object";
      this.arrayOfKeys = Object.keys(this.message);
    } else {
      this.messageType = "string";
    }
    //End
  }
  ngAfterContentChecked() {  
    if(!document.getElementById("globleMessageBanner")){
      this.dynamicHeightOfBanner = 0;
    }
    
    this.appService._commonSubjecct.subscribe((response) => {
      if (response?.event == "SHOW_BANNER_MESSAGE") {
        if (!response.message) {
          this.bannerMessagePopup.nativeElement.style.display = 'none';
          this.bannerDiv.nativeElement.style.display = 'none';
          this.createOrderBanner = response.message;
        } else {
          this.bannerMessagePopup.nativeElement.style.display = 'block';
          this.bannerDiv.nativeElement.style.display = 'block';
          this.createOrderBanner = response.message;
        }
      }
    })
  }

  ngAfterViewInit() {
      this.commonSubject = this.appService._commonComponentSubject.subscribe(
        (res) => {
          if (res) {
            if (res.action === "VALIDATE_WHEN_SELECTED_PROP") {
              this.selectedData = res.data.value;
            }
          }
        }
      );
      if(!this.message) {
        this.bannerMessagePopup.nativeElement.style.display = 'none';
        this.bannerDiv.nativeElement.style.display = 'none';
      } else {
        this.bannerMessagePopup.nativeElement.style.display = 'block';
        this.bannerDiv.nativeElement.style.display = 'block';
      }
      let bannerHeight = +this.bannerMessagePopup.nativeElement.offsetHeight;
      if(this.divIdObj && (document.getElementById(this.divIdObj.id)as HTMLElement)){
        (document.getElementById(this.divIdObj.id)as HTMLElement).style.marginTop = bannerHeight + 'px'
      };
  }

  closeBannerPopupFn = () => {
    this.bannerMessagePopup.nativeElement.style.display = 'none';
    this.bannerDiv.nativeElement.style.display = 'none';
    if(this.divIdObj && (document.getElementById(this.divIdObj.id)as HTMLElement)){
      (document.getElementById(this.divIdObj.id)as HTMLElement).style.marginTop = '0px';
    }
  }

  opePopup = (data) =>{
    let modal = new Modal({
      action: true, name: "preambleMsg", title: data?.isPopup?.title, description: data?.isPopup?.popupMsg, actionButtonText: "Cancel",
      modalForm: { modalName: "preambleMsg", type: "preambleMsg", clickEventData: "", editMode: false },
      // style: { width: "75%", height: "300px" }
    });
    this.modalService.createModalBox(modal, 200);
  }

  ngOnDestroy() {
    if(this.commonSubject){
      this.commonSubject.unsubscribe();
    }    
  }
}
